import React, { useEffect, useState } from "react";
import axios from "../api/axiosAuth";
import "../style/PendientesDocente.css"; // Importa el archivo CSS que te paso abajo

export default function PendientesDocente() {
  const [asignaciones, setAsignaciones] = useState([]);
  const [asignacion, setAsignacion] = useState("");
  const [pendientes, setPendientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({
    titulo: "",
    descripcion: "",
    fecha: ""
  });

  const cargarAsignaciones = async () => {
    try {
      const res = await axios.get("/pendientes/grados-docente");
      if (res.data.ok) setAsignaciones(res.data.data);
    } catch (err) {
      console.error("Error cargando asignaciones:", err);
    }
  };

  const cargarPendientes = async () => {
    if (!asignacion) {
      setPendientes([]);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await axios.get("/pendientes", {
        params: { asignacion_id: asignacion }
      });
      if (res.data.ok) {
        setPendientes(res.data.data || []);
        if (res.data.data.length === 0) setError("No hay pendientes");
      }
    } catch (err) {
      setError("Error cargando pendientes");
      setPendientes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { cargarAsignaciones(); }, []);
  useEffect(() => { cargarPendientes(); }, [asignacion]);

  const crearPendiente = async () => {
    if (!asignacion) return alert("Seleccione una asignación");
    if (!form.titulo || !form.fecha) return alert("Título y fecha obligatorios");

    try {
      const res = await axios.post("/pendientes", {
        asignacion_id: asignacion,
        ...form
      });
      if (res.data.ok) {
        setModal(false);
        setForm({ titulo: "", descripcion: "", fecha: "" });
        cargarPendientes();
      }
    } catch (err) {
      alert("Error creando pendiente");
    }
  };

  const cambiarEstado = async (id, estadoActual) => {
    const nuevoEstado = estadoActual === "pendiente" ? "completado" : "pendiente";
    try {
      const res = await axios.put(`/pendientes/${id}`, { estado: nuevoEstado });
      if (res.data.ok) cargarPendientes();
    } catch (err) {
      alert("Error cambiando estado");
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar este pendiente?")) return;
    try {
      const res = await axios.delete(`/pendientes/${id}`);
      if (res.data.ok) cargarPendientes();
    } catch (err) {
      alert("Error eliminando");
    }
  };

  return (
    <div className="pendientes-container">
      <div className="pendientes-header">
        <h2>📌 Pendientes del Docente</h2>
        <button className="btn-primary" onClick={() => setModal(true)}>➕ Nuevo</button>
      </div>

      <div className="filter-section">
        <select
          value={asignacion}
          onChange={(e) => setAsignacion(e.target.value)}
          className="select-custom"
        >
          <option value="">Seleccione curso</option>
          {asignaciones.map((a) => (
            <option key={a.id} value={a.id}>
              {a.grado}° - {a.grupo}
            </option>
          ))}
        </select>
      </div>

      {loading && <div className="loader">Cargando...</div>}
      {error && <p className="error-text">{error}</p>}

      {!loading && pendientes.length > 0 && (
        <div className="table-responsive">
          <table className="pendientes-table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {pendientes.map((p) => (
                <tr key={p.id}>
                  <td data-label="Título">{p.titulo}</td>
                  <td data-label="Fecha">{new Date(p.fecha).toLocaleDateString()}</td>
                  <td data-label="Estado">
                    <span className={`badge ${p.estado}`}>
                      {p.estado}
                    </span>
                  </td>
                  <td data-label="Acciones">
                    <button className="btn-icon" onClick={() => cambiarEstado(p.id, p.estado)}>✔️</button>
                    <button className="btn-icon delete" onClick={() => eliminar(p.id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Nuevo Pendiente</h3>
            <div className="form-group">
              <input
                type="text"
                placeholder="Título"
                value={form.titulo}
                onChange={(e) => setForm({ ...form, titulo: e.target.value })}
              />
              <textarea
                placeholder="Descripción"
                value={form.descripcion}
                onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
              />
              <input
                type="date"
                value={form.fecha}
                onChange={(e) => setForm({ ...form, fecha: e.target.value })}
              />
            </div>
            <div className="modal-actions">
              <button className="btn-save" onClick={crearPendiente}>💾 Guardar</button>
              <button className="btn-close" onClick={() => setModal(false)}>❌ Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}